<template>
   <!--
   <div class="modal fade" id="searchModal" tabindex="-1" aria-labelledby="searchModalLabel" aria-hidden="true">
   <div class="modal fade" id="searchModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="searchModalLabel" aria-hidden="true">
   -->
   <div class="modal fade" id="searchModal" tabindex="-1" aria-labelledby="searchModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
         <div class="modal-content bg-light">
            <!--
            <div class="modal-header px-1">
               <div class="border container px-0 bg-info">
                  <div class="border row">
                     <div class="border col px-1">
                        <div class="row justify-content-between">
                           <b class="border modal-title col" id="searchModalLabel">Buscar por:</b>
                           <div class="border form-check form-check-inline mb-0 col-2 pt-1">
                              <input 
                                 class="form-check-input" 
                                 type="radio" 
                                 name="searchOptions" 
                                 id="byText" 
                                 value="byText" 
                                 @click=" selectedsearchOptions = 'TXT' "
                                 checked
                              >
                              <label class="form-check-label" for="byText">Texto</label>
                           </div>
                           <div class="border form-check form-check-inline col-1 pt-1">
                              <input 
                                 class="form-check-input" 
                                 type="radio" 
                                 name="searchOptions" 
                                 id="byId" 
                                 value="byId"
                                 @click=" selectedsearchOptions = 'ID' "
                              >
                              <label class="form-check-label" for="byId">Id</label>
                           </div>
                           <div class="border form-check form-check-inline col-3 pt-1">
                              <input 
                                 class="form-check-input" 
                                 type="radio" 
                                 name="searchOptions" 
                                 id="byAuth" 
                                 value="byAuth"
                                 @click=" selectedsearchOptions = 'AUTH' "
                              >
                              <label class="form-check-label" for="byAuth">Aut/Doc</label>
                           </div>
                        </div>
                     </div>
                     <div class="border col-5">
                        <div class="row">
                           <b class="border modal-title col-3" id="searchModalLabel">Tablero:</b>
                           <h5 class="modal-title col" id="searchModalLabel">Buscar por:</h5>
                        </div>
                     </div>
                     <div class="border col-1 text-center">
                        <button type="button" class="btn-close" ref="btnClose" data-bs-dismiss="modal" aria-label="Close"></button>
                     </div>
                  </div>
               </div>
            </div>
            -->
            <div class="modal-header p-1">
               <div class="container px-1">
                  <div class="row m-0">
                     <div class="col-5 ps-0">
                        <b>Buscar por:</b>
                     </div>
                     <div class="col-6">
                        <b>Seleccionar Tablero:</b>
                     </div>
                     <div class="col-1 text-center px-1">
                        <button type="button" class="btn-close pb-0" ref="btnClose" data-bs-dismiss="modal" aria-label="Close"></button>
                     </div>
                  </div>
                  <div class="row m-0">
                     <div class="col-5 ps-2 pe-0 border rounded bg-white">
                           <div class="form-check form-check-inline pt-1">
                              <input 
                                 class="form-check-input border-3" 
                                 type="radio" 
                                 name="searchOptions" 
                                 id="byId" 
                                 value="byId"
                                 @click=" selectedsearchOptions = 'ID' "
                              >
                              <label class="form-check-label" for="byId">Id</label>
                           </div>
                           <div class="form-check form-check-inline pt-1">
                              <input 
                                 class="form-check-input border-3" 
                                 type="radio" 
                                 name="searchOptions" 
                                 id="byAuth" 
                                 value="byAuth"
                                 @click=" selectedsearchOptions = 'AUTH' "
                              >
                              <label class="form-check-label" for="byAuth">Aut/Doc</label>
                           </div>
                           <div class="form-check form-check-inline mb-0 pt-1">
                              <input 
                                 class="form-check-input border-3" 
                                 type="radio" 
                                 name="searchOptions" 
                                 id="byText" 
                                 value="byText" 
                                 @click=" selectedsearchOptions = 'TXT' "
                                 checked
                              >
                              <label class="form-check-label" for="byText">Texto</label>
                           </div>
                     </div>
                     <div class="col-6">
                        <select class="form-select" :disabled=" selectedsearchOptions != 'TXT' "
                              v-model="myBoardId" @change="reset(false)">
                           <option value="0" selected>Todos los Tableros</option>
                           <option value="-1">Mis Tableros</option>
                           <option v-for="(board, index) in myBoards" :key="index" :value="board.id">
                              {{ board.name }}
                           </option>
                        </select>
                     </div>
                     <!--  
                  <select 
                     v-model="specialtyValue" 
                     name="specialty" 
                     class="form-select p-0 px-1"
                     >
                     <option v-for="(specialty, index) in specialtys" :key="index" :value="specialty.id">
                        {{ specialty.name }}
                     </option>
                     <option :value="0">No Informada</option>
                  </select>
                     -->
                     <div class="col-1 text-center">
                     </div>
                  </div>
               </div>
            </div>
            <!--   -->
            <div v-if="totalItems >= 0" class="modal-body">
               <div class="list-group" v-for="(dataItem, index) in dataFound" :key="index">
                  <div class="list-group-item list-group-item-action list-group-item-light p-1">
                     <div  class="row ps-3">
                        <div v-if="dataItem.cellContent" class="p-0 cntt-resu">
                           <!-- cntt-resu
                     <div  class="d-flex flex-row">
                           <content :content="dataItem.cellContent" :cell_id="dataItem.cellId"/>
                           {{dataItem}}
                           -->
                           <content_ :content="dataItem.cellContent" :cell_id="dataItem.cellId"/>
                           <!-- <content :content="dataItem.cellContent" :cell_id="dataItem.cellId"/> -->
                        </div>
                        <div v-else class="p-0 cntt-resu bg-light border rounded">
                           <div class="text-center tc-gray fs-13">
                              <b>La vista de esta tarjeta no esta disponible en este tablero</b>
                           </div>
                        </div>
                        <div class="px-2 col">
                           <div class="d-flex flex-column">
                              <!--
                              <div class="p-0 fs-15"><b>{{dataItem.cellContent.resumeContentResponse.title}}</b></div>
                              <div class="p-0 fs-15"><b>{{dataItem.title}}</b></div>
                     <h6 class="text-break"><b><div v-html="content.title"></div></b></h6>
                              -->
                              <div class="p-0 fs-15"><b><div v-html="htmlTitle(dataItem.title)"></div></b></div>
                              <div class="p-0 tc-gray fs-13"> ID: <b>{{dataItem.id}}</b></div>
                              <div v-for="(location, index) in dataItem.locations" :key="index"
                                 class="p-0 tc-gray fs-13 container">
                                 <div class="row justify-content-start">
                                    <div class="col-auto pe-1">
                                       en la lista <b>{{location.cellName}}</b>
                                    </div>
                                    <div v-if="location.boardName" class="col-auto ps-0">
                                       del tablero <b>{{location.boardName}}</b>
                                    </div>
                                 </div>
                              </div>
                              <!--
                              <div class="p-0 tc-gray fs-13">en <b>{{dataItem.cellName}}</b></div>
                              <div class="p-0 tc-gray fs-13">en <b>{{dataItem.boardName}}</b></div>
                              -->
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
                <!--
                     <div  class="d-flex ptacion" v-on:click="closeModal($event,prestacion.codigo)">
                  ...
                  <br/>{{dataFound}}<br/>
                  ...
                -->
            </div>
            <div v-if="totalItems < 0" class="modal-body position-relative">
               <div class="position-absolute top-50 start-50 translate-middle">
                  <b><i>Esta busqueda no arrojó ningún resultado</i></b>
               </div>
            </div>
            <div class="modal-footer d-flex justify-content-between pe-4">
               <div class="col-6">
                  <div class="input-group">
                     <input ref="itSearch"
                           type="text" class="form-control"
                           v-model="inputSearch"  v-on:keyup.enter="searchContent(true)"
                     >
                     <button type="submit" class="btn btn-secondary" v-on:click="searchContent(true)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                           <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                        </svg>
                     </button>
                  </div>
               </div>
               <div class="col-2">
                  <div class="input-group">
                     <button type="button" class="btn btn-secondary py-0 px-2" v-on:click="orderSwich()">
                        <svg v-if="searchOrderSwich" xmlns="http://www.w3.org/2000/svg" width="24" height="36" fill="currentColor" class="bi bi-sort-alpha-down" viewBox="0 0 14 16">
                           <path fill-rule="evenodd" d="M10.082 5.629 9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371zm1.57-.785L11 2.687h-.047l-.652 2.157z"/>
                           <path d="M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293z"/>
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="36" fill="currentColor" class="bi bi-sort-numeric-down-alt" viewBox="0 0 14 16">
                           <path fill-rule="evenodd" d="M11.36 7.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.836 1.973-1.836 1.09 0 2.063.637 2.063 2.688 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98"/>
                           <path d="M12.438 8.668V14H11.39V9.684h-.051l-1.211.859v-.969l1.262-.906h1.046zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293z"/>
                        </svg>
                     </button>
                     <button type="button" class="btn btn-secondary py-0 px-2" v-on:click="$emit('carousel', dataFound)">
                        <!--
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="36" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
                           <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
                           <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
                        </svg>
                        -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" fill="currentColor" class="bi bi-arrow-left-right" viewBox="0 0 16 16">
                           <path fill-rule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"/>
                        </svg>
                     </button>
                  </div>
               </div>
               <nav aria-label="Page navigation example" class=" col-3 pgnav">
                  <ul class="pagination text-muted d-flex">
                     <li class="page-item">
                        <button type="button" class="page-link text-muted" v-on:click="addItems()">
                           <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-plus-lg mb-1" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                           </svg>
                        </button>
                     </li>
                     <!--
                     <li class="page-item disabled el-del-medio"><a class="page-link hgt-del-medio">{{itemsShow}}/{{totalItems}}</a></li>
                     -->
                     <li class="page-item disabled flex-grow-1 text-center"><a class="page-link hgt-del-medio">{{itemsShow}}/{{totalItems}}</a></li>
                     <li class="page-item">
                        <!--
                        <button type="button" class="page-link text-muted" v-on:click="$emit('carousel', dataFound)">
                        -->
                        <button type="button" class="page-link text-muted" v-on:click="reset( true )">
                           <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-eraser mb-1" viewBox="0 0 16 16">
                              <path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414l-3.879-3.879zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z"/>
                           </svg>
                        </button>
                     </li>
                  </ul>
               </nav>
            </div>
         </div>
      </div>
   </div>
   <!--
   -->
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue'
import WspService from "../workSpace.service";
import { useStore } from 'vuex'

import content_ from './ContentTableTypeList.vue';

export default {
   components: {
      content_,
   },
   emits: [ 'carousel' ],
   setup() {
      const store = useStore()
      const boardId = ref(WspService.getBoardId(store))

      const dataFound = ref([])
      const inputSearch = ref('')
      const itSearch = ref(null)
      const itemsShow = ref(0)
      const totalItems = ref(0)

      const selectedsearchOptions = ref('TXT')
      const searchOrderSwich = ref(true)

      const myBoardId = ref(0)
      const myBoards = ref({})
      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })

      const addItems = () => {
         if (itemsShow.value < totalItems.value) {
            searchContent(false)
         }
      }

      const findMyBoards = () => {
         WspService.findMyBoards( currentUserId.value )
         .then(response => {
            console.log("findMyBoards: " + response.data)
            myBoards.value = response.data
         })
         .catch(error => {
            console.log(error);
         });
      }

      const reset = ( value ) => {
         if ( value ) {
            inputSearch.value = ''
            myBoardId.value = 0
         }
         dataFound.value = []
         itemsShow.value = 0
         totalItems.value = 0
         boardId.value = WspService.getBoardId(store)
         itSearch.value.focus()
      }

      const htmlTitle = ( text ) => {
         return WspService.htmlSeparator( text );
      }

      const orderSwich = () => {
         searchOrderSwich.value = !searchOrderSwich.value
         if ( inputSearch.value != '' ) {
            dataFound.value = []
            itemsShow.value = 0
            totalItems.value = 0
            boardId.value = WspService.getBoardId(store)
            searchContent(true)
         }
      }

      const searchContent = (start) => {
         if ( inputSearch.value != '' ) {
            if (start) {
               dataFound.value = []
               itemsShow.value = 0
               totalItems.value = 0
               boardId.value = WspService.getBoardId(store)
            }
            WspService.findContentByString(
               boardId.value,       // boardId,
               10,                  // itemsByPage, 
               itemsShow.value,     //  start, 
               inputSearch.value,    // searchText
               selectedsearchOptions.value, // searchOption
               searchOrderSwich.value, // searchOrder
               myBoardId.value   // filterBoardId
               )
            .then(response => {
               dataFound.value.push(...response.data.contentList)
               //dataFound.value = response.data.contentList
               totalItems.value = response.data.totalItems
               //console.log("searchContent: " + response.data.contentList)
               itemsShow.value = dataFound.value.length
               if ( start && totalItems.value == 0) {
                  totalItems.value = -1
               }
            })
            .catch(error => {
               console.log(error);
            });
         }
      }

      onMounted(() => {
         document.getElementById('searchModal')
         .addEventListener('show.bs.modal', function () {
            //let button = event.relatedTarget
            reset( false )
            findMyBoards()
            //cellId.value = button.getAttribute('data-cell-id')
         })
         console.log("search modal")
      })

      watch(() => selectedsearchOptions.value, () => {
         //console.log(selectedsearchOptions.value)
         reset(true)
      })
      
      return {
         addItems,
         dataFound,
         htmlTitle,
         inputSearch,
         itSearch,
         itemsShow,
         myBoardId,myBoards,
         orderSwich,
         reset,
         searchContent, searchOrderSwich,
         selectedsearchOptions,
         totalItems
      };
   }
}
</script>

<style scoped>
.pgnav {
    height: 38px;
}
.modal-dialog-scrollable .modal-content {
    /*max-height: 100%;*/
    height: 100%;
    overflow: hidden;
}
.modal-header .btn-close {
    padding: .5rem .5rem;
    margin: -.5rem -.5rem -.5rem -.5rem;
}
.opcBusqueda {
    padding: .5rem .5rem;
    margin: -.5rem 1.5rem -.5rem auto;
}
.el-del-medio {
   
   margin-left: auto;
   margin-right: auto;
   
}
.hgt-del-medio {
   height: 40px;
}
.tc-gray {
   color: gray;
}
.tc-d-gray {
   color: darkslategray;
}
.fs-11 {
   font-size: 11px;
}
.fs-12 {
   font-size: 12px;
}
.fs-13 {
   font-size: 13px;
}
.fs-14 {
   font-size: 14px;
}
.fs-15 {
   font-size: 15px;
}
.cntt-resu {
   width: 210px;
}
.bg-white {
   background-color: white;
}
</style>